import classNames from "classnames";
import { ButtonBack, ButtonNext, Slide, Slider } from "pure-react-carousel";
import React from "react";
import { ArrowIcon } from "../../icons/ArrowIcon";
import { SlideshowSlide } from "./SlideshowSlide";

export const SlideshowInside: React.FC<{
  slides: Array<Queries.ContentBlockFragment>;
}> = ({ slides }) => {
  return (
    <>
      <ButtonBack className="z-20 col-span-1 col-start-2 row-start-2 justify-self-start disabled:opacity-0 lg:col-span-2 lg:col-start-1 lg:justify-self-center">
        <ArrowIcon className="h-60px text-hyacinth" />
      </ButtonBack>
      <Slider
        className={classNames("row-start-1", "col-span-full col-start-1")}
      >
        {slides.map((s, i) => (
          <Slide key={s.id} index={i}>
            <SlideshowSlide slide={s} index={i} count={slides.length} />
          </Slide>
        ))}
      </Slider>
      <ButtonNext className="z-20 col-span-1 col-start-5 row-start-2 justify-self-end disabled:opacity-0 md:col-span-1 md:col-start-9 lg:col-span-2 lg:col-start-15 lg:justify-self-center">
        <ArrowIcon className="h-60px rotate-180 transform-gpu text-hyacinth" />
      </ButtonNext>
    </>
  );
};
